"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_provider_1 = require("../config-provider");
var info_boundary_1 = tslib_1.__importDefault(require("../info-boundary"));
var GroupContext_1 = require("./GroupContext");
var Group = function (props) { return (React.createElement(config_provider_1.ConfigConsumer, null, function (_a) {
    var _b;
    var getPrefixCls = _a.getPrefixCls, direction = _a.direction;
    var customizePrefixCls = props.prefixCls, _c = props.className, className = _c === void 0 ? '' : _c;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, classnames_1.default)(prefixCls, (_b = {},
        _b["".concat(prefixCls, "-lg")] = props.size === 'large',
        _b["".concat(prefixCls, "-sm")] = props.size === 'small',
        _b["".concat(prefixCls, "-compact")] = props.compact,
        _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _b), className);
    return (React.createElement("span", { className: cls, style: props.style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, onFocus: props.onFocus, onBlur: props.onBlur },
        React.createElement(GroupContext_1.GroupContext.Provider, { value: GroupContext_1.defaultGroupContext }, props.children)));
})); };
exports.default = (0, info_boundary_1.default)(Group);
//# sourceMappingURL=Group.js.map